import { ControlIcons } from 'owa-control-icons';
import { FilterableMenuItem } from 'owa-filterable-menu';
import { editWacFileAction } from 'owa-group-files-hub-actions';
import { getSxSViewStore, EditMode } from 'owa-group-files-hub-store';
import {
    getDefaultPreviewPaneCommandBarItems,
    getHeroMenuItemClassName,
    PreviewPaneCommandBarItem,
} from 'owa-sxs/lib/utils/PreviewPaneCommandBarButton';
import strings from 'owa-strings/owa-mail-strings';
import { PreviewPaneMode } from 'owa-sxsdata';

export default function getCommandButtonsForSxSPreview(): PreviewPaneCommandBarItem[] {
    const store = getSxSViewStore();
    const editButton = new FilterableMenuItem(
        strings.EditButtonLabel,
        ControlIcons.Edit,
        () => {
            if (store.viewState && store.viewState.previewPane && store.viewState.previewPane.id) {
                editWacFileAction(store.viewState.previewPane.id);
            }
        },
        () => {
            return (
                store.viewState &&
                store.viewState.previewPane &&
                store.viewState.previewPane.mode == PreviewPaneMode.Wac &&
                store.wacFileEditState.editAllowed &&
                store.wacFileEditState.mode == EditMode.View
            );
        }
    );

    editButton.ariaLabel = strings.EditButtonLabel;
    editButton.className = getHeroMenuItemClassName();

    return [editButton, ...getDefaultPreviewPaneCommandBarItems()];
}
